import { useAuth } from '../context/AuthContext';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from './ui/alert-dialog';
import { ShoppingCart, AlertTriangle } from 'lucide-react';

const LogoutConfirmDialog = () => {
    const { pendingLogout, reservationCount, confirmLogout, cancelLogout } = useAuth();

    return (
        <AlertDialog open={pendingLogout} onOpenChange={(open) => !open && cancelLogout()}>
            <AlertDialogContent className="max-w-md">
                <AlertDialogHeader>
                    <div className="flex items-center gap-3 mb-2">
                        <div className="p-2 bg-amber-100 rounded-full">
                            <AlertTriangle className="w-6 h-6 text-amber-600" />
                        </div>
                        <AlertDialogTitle className="text-xl">
                            Réservations en cours
                        </AlertDialogTitle>
                    </div>
                    <AlertDialogDescription className="text-base text-slate-600">
                        <div className="flex items-center gap-2 p-3 bg-amber-50 rounded-lg border border-amber-200 mb-4">
                            <ShoppingCart className="w-5 h-5 text-amber-600" />
                            <span className="font-medium text-amber-800">
                                Vous avez {reservationCount} article{reservationCount > 1 ? 's' : ''} réservé{reservationCount > 1 ? 's' : ''} dans votre panier
                            </span>
                        </div>
                        <p>
                            Si vous vous déconnectez, vos réservations seront <strong className="text-red-600">annulées</strong> et les produits redeviendront disponibles pour d'autres clients.
                        </p>
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter className="mt-4">
                    <AlertDialogCancel 
                        onClick={cancelLogout}
                        className="bg-slate-100 hover:bg-slate-200"
                    >
                        Annuler
                    </AlertDialogCancel>
                    <AlertDialogAction 
                        onClick={confirmLogout}
                        className="bg-red-600 hover:bg-red-700 text-white"
                    >
                        Me déconnecter quand même
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};

export default LogoutConfirmDialog;
